import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=0a88746c"
import script from "./Preloader.js?vue&type=script&lang=js&external"
export * from "./Preloader.js?vue&type=script&lang=js&external"
import style0 from "./Preloader.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports